/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useStore } from 'vuex';
import { DEFAULT_LANGUAGE, INTL_LOCALE_MAP, USLanguageOptions } from '@hems/util/src/constant/languages';
import { APP_CTX_ACTION } from '@hems/util/src/stores/modules/appCtx';
export const useLanguage = () => {
    const store = useStore();
    const languageCode = computed(() => store.state.appCtx.langCd ?? DEFAULT_LANGUAGE);
    const intlLocaleCode = computed(() => INTL_LOCALE_MAP[languageCode.value]);
    const languageOptionsForManagement = computed(() => USLanguageOptions);
    const setLanguage = (language) => {
        store.dispatch(APP_CTX_ACTION.SET_LANG_CD, language);
    };
    const setIntlLocale = () => {
        store.dispatch(APP_CTX_ACTION.SET_LOCALE);
    };
    return { languageCode, languageOptionsForManagement, setLanguage, setIntlLocale, intlLocaleCode };
};
